import 'magnific-popup';
import UIkit from 'uikit';

export default function () {
    const servicesContainer = UIkit.util.$('.tm-services');
    const triggerCls = '.tm-services__item-dialog';
    const contentCls = '.tm-services__item-back';

    UIkit.util.on(servicesContainer, 'click', triggerCls, function(e) {
        e.preventDefault();

        const $el = $(e.target);
        const content = $el.siblings(contentCls);

        $.magnificPopup.open({
            items: {
                src: `<div class="mfp-content-inner" style="max-width: 560px">${content[0].innerHTML}</div>`,
                type: 'inline',
            },
            removalDelay: 500,
        })
    })
}


// WEBPACK FOOTER //
// ./scripts/tourism/services.js